import { render, staticRenderFns } from "./ShiftPatternEdit.vue?vue&type=template&id=3110e544"
import script from "../../controllers/shift_pattern/shift-pattern-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/shift_pattern/shift-pattern-edit.js?vue&type=script&lang=js&external"
import style0 from "./ShiftPatternEdit.vue?vue&type=style&index=0&id=3110e544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports